export default __webpack_public_path__ + "static/media/thick1.55374b3a.svg";